import useQueryConsistencyCheckDetailsFetch from '@hooks/consistencyCheckDetails/useQueryConsistencyCheckDetailsFetch';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { IComparisonId } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TConsistencyCheckDetailsDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { useQueriesConsistencyCheckDetailsMoFilters } from './useQueriesConsistencyCheckDetailsMoFilters';
import useQueryConsistencyCheckConfigIds from './useQueryConsistencyCheckConfigIds';
import useQueryConsistencyCheckDeltas from './useQueryConsistencyCheckDetailsDeltas';
import useQueryConsistencyCheckDetailsMoNames from './useQueryConsistencyCheckDetailsMoNames';
import useQueryConsistencyCheckParameters from './useQueryConsistencyCheckDetailsParameters';
import useQueryConsistencyCheckSiteIds from './useQueryConsistencyCheckDetailsSiteIds';
import useQueryConsistencyCheckGnbIds from './useQueryConsistencyCheckGnbIds';

type TUseConsistencyCheckBranchParams = ICMMavenirVendor & TConsistencyCheckDetailsDTO & IComparisonId

const useConsistencyCheckDetails = (params: TUseConsistencyCheckBranchParams) => {
	const { comparisonId, isMavenirVendor } = params;

	const {
		details,
		countOfRecords,
		isLoadingDetails,
		dataSourceCreatedAt,
	} = useQueryConsistencyCheckDetailsFetch(params);

	const { parametersOptions } = useQueryConsistencyCheckParameters(comparisonId);

	const { siteIdsOptions } = useQueryConsistencyCheckSiteIds(comparisonId);

	const { gnbIdsOptions } = useQueryConsistencyCheckGnbIds(comparisonId);

	const { configIdsOptions } = useQueryConsistencyCheckConfigIds(comparisonId);

	const { deltasOptions } = useQueryConsistencyCheckDeltas(comparisonId);

	const { moNames, isLoadingMoNames } = useQueryConsistencyCheckDetailsMoNames({ comparisonId, isMavenirVendor });

	const { detailsMoFilters } = useQueriesConsistencyCheckDetailsMoFilters({ comparisonId, moNames });

	return {
		isLoadingDetails: isLoadingDetails || isLoadingMoNames,
		detailsMoFilters,
		moNames,
		details,
		countOfRecords,
		deltasOptions,
		parametersOptions,
		siteIdsOptions,
		gnbIdsOptions,
		configIdsOptions,
		dataSourceCreatedAt,
	};
};

export default useConsistencyCheckDetails;
